import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { recentSearches } from '../../../common/constants';
import './SearchBarComponent.scss';

interface SearchBarPropsComponent {
	handleSearch: () => void;
	handleClose?: () => void;
	placeholder?: string;
	startSuggestionSearch: (term: string) => void;
	value?: string;
	reset: () => void;
	handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	handleClearSearch: () => void;
}

export const SearchBarComponent: FC<SearchBarPropsComponent> = ({
	handleSearch,
	placeholder,
	handleClose,
	value,
	reset,
	handleChange,
	handleClearSearch
}) => {
	const [recent, setRecent] = useState<string[]>([]);
	const [showRecent, setShowRecent] = useState(false);
	const [disableHover, setDisableHover] = useState(false);
	const defaultPlaceholder = 'Search for products, brands, ingredients and more';
	const inputRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		const storedRecentSearches = JSON.parse(localStorage.getItem(recentSearches) || '[]');
		setRecent(storedRecentSearches);
	}, []);

	useEffect(() => {
		const loadRecent = () => {
			const stored = JSON.parse(localStorage.getItem(recentSearches) || '[]');
			setRecent(stored);
		};
		loadRecent();
		window.addEventListener('recentSearchUpdated', loadRecent);
		return () => {
			window.removeEventListener('recentSearchUpdated', loadRecent);
		};
	}, []);

	const closeIconCick = useCallback(() => {
		reset();
		handleClose && handleClose();
		handleClearSearch();
	}, [handleClearSearch, handleClose, reset]);
	const handleKeyUp = useCallback(
		(event: React.KeyboardEvent<HTMLInputElement>) => {
			event.preventDefault();
			if (event.key === 'Enter' && event.currentTarget.value.trim()) {
				if (inputRef.current) {
					inputRef.current?.blur();
					setDisableHover(true);
				}
				postSearchItem(event.currentTarget.value.trim());
				handleSearch();
				setShowRecent(false);
			}
		},
		[handleSearch]
	);

	const handleRecentClick = useCallback(
		(term: string) => {
			if (handleChange) {
				handleChange({ target: { value: term } } as React.ChangeEvent<HTMLInputElement>);
			}
			postSearchItem(term);
			setShowRecent(false);
		},
		[handleSearch]
	);

	const postSearchItem = (term: any) => {
		const recentSearchData = [term, ...recent.filter(r => r !== term)].slice(0, 6);
		localStorage.setItem(recentSearches, JSON.stringify(recentSearchData));
		setRecent(recentSearchData);
	};

	const clearRecentSeraches = () => {
		localStorage.removeItem(recentSearches);
		setRecent([]);
	};

	return (
		<div className='search-bar-container'>
			<input
				ref={inputRef}
				type='text'
				className={`search-bar ${value ? 'typing' : ''} ${disableHover ? 'disable-hover' : ''}`}
				value={value}
				onChange={handleChange}
				placeholder={placeholder || defaultPlaceholder}
				onKeyUp={handleKeyUp}
				onFocus={() => {
					setShowRecent(true);
					setDisableHover(false);
				}}
				onBlur={() => setShowRecent(false)}
			/>
			{showRecent && recent.length > 0 && (
				<div className='recent-dropdown'>
					<div className='recent-header'>
						<span>Recent Searches</span>
					</div>
					<div className='recent-item-list'>
						<ul className='recent-list'>
							{recent.map((r, i) => (
								<li
									key={i}
									className='recent-item'
									onMouseDown={e => {
										e.preventDefault();
										handleRecentClick(r);
									}}
								>
									{r}
								</li>
							))}
						</ul>
					</div>
					<div
						className='clear-recent'
						onMouseDown={e => {
							e.preventDefault();
							clearRecentSeraches();
						}}
					>
						Clear Recent Searches
					</div>
				</div>
			)}
			<div className={`icons-container ${!value ? 'empty-wrapper' : ''}`}>
				{value && <i className='ri-close-line clean-icon' onClick={closeIconCick}></i>}
				<i
					className='ri-search-line search-icon'
					onClick={() => {
						postSearchItem(value);
						handleSearch();
					}}
				></i>
			</div>
		</div>
	);
};

// import { FC, useCallback, useEffect, useRef, useState } from 'react';
// import { recentSearches } from '../../../common/constants';
// import './SearchBarComponent.scss';
// import {
// 	getIirisCookie,
// 	getLocalStorageValue,
// 	IirisIdentityKey
// } from '../../../helpers/authenticationHelper';

// interface SearchBarPropsComponent {
// 	handleSearch: () => void;
// 	handleClose?: () => void;
// 	placeholder?: string;
// 	startSuggestionSearch: (term: string) => void;
// 	value?: string;
// 	reset: () => void;
// 	handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
// 	handleClearSearch: () => void;
// }

// export const SearchBarComponent: FC<SearchBarPropsComponent> = ({
// 	handleSearch,
// 	placeholder,
// 	handleClose,
// 	value,
// 	reset,
// 	handleChange,
// 	handleClearSearch
// }) => {
// 	const [recent, setRecent] = useState<string[]>([]);
// 	const [showRecent, setShowRecent] = useState(false);
// 	const [disableHover, setDisableHover] = useState(false);
// 	const defaultPlaceholder = 'Search for products, brands, ingredients and more';
// 	const inputRef = useRef<HTMLInputElement>(null);

// 	const emailId = getLocalStorageValue(IirisIdentityKey.USER_EMAIL);
// 	const token = getIirisCookie();

// 	useEffect(() => {
// 		const storedRecentSearches = JSON.parse(localStorage.getItem(recentSearches) || '[]');
// 		setRecent(storedRecentSearches);
// 	}, []);

// 	useEffect(() => {
// 		const loadRecent = () => {
// 			const stored = JSON.parse(localStorage.getItem(recentSearches) || '[]');
// 			setRecent(stored);
// 		};
// 		loadRecent();
// 		window.addEventListener('recentSearchUpdated', loadRecent);
// 		return () => {
// 			window.removeEventListener('recentSearchUpdated', loadRecent);
// 		};
// 	}, []);

// 	const closeIconCick = useCallback(() => {
// 		reset();
// 		handleClose && handleClose();
// 		handleClearSearch();
// 	}, [handleClearSearch, handleClose, reset]);
// 	const handleKeyUp = useCallback(
// 		(event: React.KeyboardEvent<HTMLInputElement>) => {
// 			event.preventDefault();
// 			if (event.key === 'Enter' && event.currentTarget.value.trim()) {
// 				if (inputRef.current) {
// 					inputRef.current?.blur();
// 					setDisableHover(true);
// 				}
// 				postSearchItem(event.currentTarget.value.trim());
// 				handleSearch();
// 				setShowRecent(false);
// 			}
// 		},
// 		[handleSearch]
// 	);

// 	const handleRecentClick = useCallback(
// 		(term: string) => {
// 			if (handleChange) {
// 				handleChange({ target: { value: term } } as React.ChangeEvent<HTMLInputElement>);
// 			}
// 			postSearchItem(term);
// 			setShowRecent(false);
// 		},
// 		[handleSearch]
// 	);

// 	const postSearchItem = (term: any) => {
// 		const recentSearchData = [term, ...recent.filter(r => r !== term)].slice(0, 6);
// 		localStorage.setItem(recentSearches, JSON.stringify(recentSearchData));
// 		setRecent(recentSearchData);
// 	};

// 	const clearRecentSeraches = () => {
// 		localStorage.removeItem(recentSearches);
// 		setRecent([]);
// 	};

// 	const getCognitoMailId = async () => {
// 		try {
// 			const response = await fetch(
// 				`${
// 					import.meta.env.VITE_IRIS_DOMAIN
// 				}/v3/authorization/public/passport/userdetails?client_id=${
// 					import.meta.env.VITE_CLIENT_ID
// 				}&username=${emailId}`
// 			);
// 			if (!response.ok) {
// 				throw new Error('Failed to fetch recent searches');
// 			}
// 			const data = await response.json();
// 			getRecentSearches(data?.data?.Username);
// 			return data;
// 		} catch (error) {
// 			console.error('Error fetching recent searches:', error);
// 		}
// 	};

// 	const getRecentSearches = async (cognitoUserId: string) => {
// 		try {
// 			const response = await fetch(
// 				`${import.meta.env.VITE_BEACON_API_URL}/search/${cognitoUserId}`,
// 				{ headers: { Authorization: token || '', email: emailId || '' } }
// 			);
// 			if (!response.ok) {
// 				throw new Error('Failed to fetch recent searches');
// 			}
// 			const data = await response.json();
// 			const recentTerms =
// 				data?.recentSearches?.map((item: { term: string }) => item.term).slice(0, 6) || [];
// 			setRecent(recentTerms);
// 			return data;
// 		} catch (error) {
// 			console.error('Error fetching recent searches:', error);
// 		}
// 	};

// 	useEffect(() => {
// 		getCognitoMailId();
// 	}, []);

// 	return (
// 		<div className='search-bar-container'>
// 			<input
// 				ref={inputRef}
// 				type='text'
// 				className={`search-bar ${value ? 'typing' : ''} ${disableHover ? 'disable-hover' : ''}`}
// 				value={value}
// 				onChange={handleChange}
// 				placeholder={placeholder || defaultPlaceholder}
// 				onKeyUp={handleKeyUp}
// 				onFocus={() => {
// 					setShowRecent(true);
// 					setDisableHover(false);
// 				}}
// 				onBlur={() => setShowRecent(false)}
// 			/>
// 			{showRecent && recent.length > 0 && (
// 				<div className='recent-dropdown'>
// 					<div className='recent-header'>
// 						<span>Recent Searches</span>
// 					</div>
// 					<div className='recent-item-list'>
// 						<ul className='recent-list'>
// 							{recent.map((r, i) => (
// 								<li
// 									key={i}
// 									className='recent-item'
// 									onMouseDown={e => {
// 										e.preventDefault();
// 										handleRecentClick(r);
// 									}}
// 								>
// 									{r}
// 								</li>
// 							))}
// 						</ul>
// 					</div>
// 					<div
// 						className='clear-recent'
// 						onMouseDown={e => {
// 							e.preventDefault();
// 							clearRecentSeraches();
// 						}}
// 					>
// 						Clear Recent Searches
// 					</div>
// 				</div>
// 			)}
// 			<div className={`icons-container ${!value ? 'empty-wrapper' : ''}`}>
// 				{value && <i className='ri-close-line clean-icon' onClick={closeIconCick}></i>}
// 				<i
// 					className='ri-search-line search-icon'
// 					onClick={() => {
// 						postSearchItem(value);
// 						handleSearch();
// 					}}
// 				></i>
// 			</div>
// 		</div>
// 	);
// };
